export type MotionMode = "full" | "reduced";

export function getMotionMode(prefersReducedMotion: boolean): MotionMode {
  return prefersReducedMotion ? "reduced" : "full";
}
